<template>
    <detail-panel class="standard-detail-panel"
        :name="name"
        ref="p">
        <div class="standard-detail-panel-title"
            slot="header">
            <span>户型管理</span>
            <Button :disabled="loading"
                v-if="isActive && $can('add')"
                class="standard-detail-panel-header-btn"
                type="primary"
                size="small"
                @click.stop="addHouse">新增户型</Button>
        </div>
        <Table :loading="loading"
            :columns="columns"
            :data="tableData"
            class="standard-detail-inner-table"
            :height="500">
            <template v-slot:action="{ row }">
                <Button :disabled="loading"
                    type="default"
                    size="small"
                    style="margin-right: 5px;"
                    @click="toShowHouseInfo(row)">详情</Button>
                <PoptipButton v-if="$can('delete')"
                    :disabled="loading"
                    text="删除"
                    transfer
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="() => { rowConfirmDelete(row) }"></PoptipButton>
            </template>
        </Table>
        <smart-modal v-model="showHouseInfo"
            :title="houId ? '编辑户型信息' : '新增户型信息'"
            :height="540"
            :width="800"
            :maskClosable="false"
            :buttons.sync="houseFormBtns"
            @close-by-confirm="fetch">
            <house-form v-if="showHouseInfo"
                :id="houId"></house-form>
        </smart-modal>
    </detail-panel>
</template>
<script>
import { panelable, Panel as DetailPanel } from '_c/panel'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import Dict from '@/utils/dict'
import { houseList, houseDelete } from '@/api/proj-manager'
import HouseForm from './form'

export default {
    access: "projHouse",
    props: {
        name: String
    },
    mixins: [panelable],
    components: {
        DetailPanel,
        HouseForm
    },
    data() {
        return {
            houId: '',
            showHouseInfo: false,
            houseFormBtns: [],
            tableData: [],
            dict: {
                saleStatus: Dict.NULL
            },
            loading: false
        }
    },
    computed: {
        columns() {
            return [{
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 80
                },
                {
                    key: 'houseName',
                    title: '户型类别',
                    align: 'left',
                    minWidth: 150
                },
                {
                    key: 'houseType',
                    title: '户型',
                    align: 'left',
                    minWidth: 150
                },
                {
                    key: 'saleStatus',
                    title: '状态',
                    align: 'center',
                    minWidth: 150,
                    render: mapCell(this.dict.saleStatus.val())
                },
                {
                    key: 'price',
                    title: '售价(万元/套)',
                    align: 'right',
                    minWidth: 150,
                    render: pipeCell('currency')
                },
                {
                    key: 'buildArea',
                    title: '建筑面积(m²)',
                    align: 'right',
                    minWidth: 150,
                    render: pipeCell('currency')
                },
                {
                    key: 'layout',
                    title: '户型分布',
                    align: 'left',
                    minWidth: 150
                },
                {
                    key: 'description',
                    title: '户型解析',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    slot: 'action',
                    minWidth: 180
                }
            ]
        }
    },
    methods: {
        fetch() {
            this.loading = true
            return houseList(this.projId).then(res => {
                this.tableData = res.data.list || []
                this.loading = false
                return Promise.resolve()
            })
        },
        addHouse() {
            this.houId = ''
            this.showHouseInfo = true
        },
        toShowHouseInfo(row) {
            this.houId = row.id
            this.showHouseInfo = true
        },
        rowConfirmDelete(row) {
            this.loading = true
            houseDelete(row.id)
                .then(el => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        }
    },
    created() {
        this.projId = this.$route.params.id
        this.loading = true
        Promise.all([Dict.get(['sale_status']), this.fetch()])
            .then(args => {
                let [dict] = args
                Object.keys(this.dict).forEach(key => {
                    this.dict[key] = dict[key]
                })
            })
            .finally(() => (this.loading = false))
    }
}
</script>